import { IContactRepository } from '../../../domain/repositories/contact.repository.interface';
import { CreateContactMessageDTO } from '../../dtos/contact/create-contact-message.dto';

export class SubmitPublicContactUseCase {
  constructor(private readonly repository: IContactRepository) {}

  public async execute(data: CreateContactMessageDTO): Promise<{ id: string }> {
    return this.repository.submitPublicMessage(data);
  }
}
